import React from "react"
import styled from "styled-components"
import { device } from "../../utils/breakpoints"
import { colors } from "../../utils/theme"

const ItemNumber = styled.div`
  padding-bottom: 1rem;
  h4 {
    font-family: "sketter";
    color: white;
    margin-bottom: 1rem;
    text-align: center;
    @media ${device.md} {
      text-align: center;
    }
    & span {
      position: relative;
      padding: 0.4em 1em;
      border: none !important;
      &::after {
        content: "";
        width: 100%;
        height: 100%;
        border: 4px solid ${colors.sColor};
        position: absolute;
        left: 0;
        top: 0;
        transform: skew(-7deg);
      }
    }
  }
  p {
    font-size: 0.9em;
    text-align: center;
    @media ${device.md} {
      font-size: 0.7em;
      text-align: center;
    }
    & strong {
      font-weight: 800;
      text-transform: uppercase;
    }
    & i {
      font-weight: 800;
      text-transform: uppercase;
      font-style: italic;
      color: ${colors.sColor};
    }
  }
`

function Item({ number, desc }) {
  return (
    <ItemNumber>
      <h4>
        <span>{number}.</span>
      </h4>
      <div dangerouslySetInnerHTML={{ __html: desc }} />
    </ItemNumber>
  )
}

export default Item
